import { useMemo } from "react";
import useWelcomeSearch, {
  numberWidget,
  messagesTodayLink,
  alertsOrEventsLink
} from "components/welcome/hooks/useWelcomeSearch";
import useMetricsTimeRange from "components/welcome/hooks/useMetricsTimeRange";
import usePermittedAlertsEventsStreams from "components/welcome/hooks/usePermittedAlertsEventsStreams";
import WidgetPosition from "views/logic/widgets/WidgetPosition";
import { KPI_WIDGET_GRID_HEIGHT } from "../Constants";
const buildEntries = (timeRange, permittedAlertsEventsStreams) => {
  const messages = numberWidget({ title: "Messages Today", timeRange, link: messagesTodayLink(timeRange) });
  if (permittedAlertsEventsStreams.length === 0) {
    return [{ ...messages, position: new WidgetPosition(1, 1, KPI_WIDGET_GRID_HEIGHT, 12) }];
  }
  return [
    { ...messages, position: new WidgetPosition(1, 1, KPI_WIDGET_GRID_HEIGHT, 6) },
    {
      ...numberWidget({
        title: "Total Alerts",
        timeRange,
        link: alertsOrEventsLink(timeRange, true),
        queryString: "alert:true",
        streams: permittedAlertsEventsStreams
      }),
      position: new WidgetPosition(7, 1, KPI_WIDGET_GRID_HEIGHT, 6)
    }
  ];
};
const useSecurityKpisSearch = () => {
  const rangeSeconds = useMetricsTimeRange();
  const permittedAlertsEventsStreams = usePermittedAlertsEventsStreams();
  const timeRange = useMemo(() => ({ type: "relative", from: rangeSeconds }), [rangeSeconds]);
  const entries = useMemo(
    () => buildEntries(timeRange, permittedAlertsEventsStreams),
    [timeRange, permittedAlertsEventsStreams]
  );
  return useWelcomeSearch(entries, timeRange);
};
export default useSecurityKpisSearch;
